import { del, get, post } from "../api/client";
import { onApiError } from "../error";

/**
 * @param {string} id 
 */
async function delNotice(id) {
    const res = await del(`/notices/${id}`)
    if (!res.ok) throw await onApiError(res)
}

/**
 * @param {boolean} isPublic 
 * @returns {Promise<Notice[]>}
 */
async function getNotices(isPublic) {
    const url = isPublic ? "/notices?public" : "/notices"
    const res = await get(url)
    if (!res.ok) throw onApiError(res)
    return res.json()
}

/**
 * 
 * @param {Object} notice
 * @param {boolean} notice.Public
 * @param {string} notice.English
 * @param {string} notice.French
 * @param {string} notice.German
 * @param {string} notice.Swedish
 * @returns 
 */
async function postNotice(notice) {
    const res = await post("/notices", {
        body: JSON.stringify(notice)
    })
    if (!res.ok) throw onApiError(res)
    return res.json()
}

export {
    delNotice,
    getNotices,
    postNotice,
}